<template>
    <div class="BankPage">
        <MainPageHeader/>
        <div class="content">
            <h1 class="how-it-works font-size-big">How It Works</h1>
            <h3 class="sub-header font-size-middle">
              Please check the payment process for where your bank account is based.
            </h3>
            <BankTabber
                class="tabber"
                :tabs="[ 'United States', 'France & Germany' ]"
                :activeTab="activeTab"
                @tabselected="activeTab = $event"
                />
            <div class="row">
                <div class="points-us" v-if="activeTab === 0">
                    <BankRow title="Add a bank account" :index="1"
                        @click="selectPoint(0, 0)"
                        :active="selectedPoint[0] == 0"
                        >
                        <h2 class="font-size-middle">Enter banking details</h2>
                    </BankRow>
                    <BankRow title="Verify bank account" :index="2"
                        @click="selectPoint(0, 1)"
                        :active="selectedPoint[0] == 1"
                        >
                        <h2 class="clickable font-size-middle" @click="selectPoint(0, 1)">
                            A. Real-time authentication
                        </h2>
                        <span class="font-size-middle">or</span>
                        <h2 class="clickable font-size-middle" @click="selectPoint(0, 1)">
                            B. 2 business day micropayment verification for some U.S. accounts
                        </h2>
                    </BankRow>
                    <BankRow title="Make payment" :index="3" :streak="false"
                        @click="selectPoint(0, 2)"
                        :active="selectedPoint[0] == 2"
                        >
                        <h2 class="font-size-middle">Once verification is successful, simply pay online</h2>
                        <span class="font-size-middle">
                          Funds take 4-5 business days to reach the supplier’s account
                        </span>
                    </BankRow>
                </div>
                <div class="points-fr-gr" v-else>
                    <BankRow title="Add a bank account" :index="1"
                        @click="selectPoint(1, 0)"
                        :active="selectedPoint[1] == 0"
                        >
                        <h2 class="font-size-middle">Enter banking details</h2>
                    </BankRow>
                    <BankRow title="Verify bank account" :index="2"
                        @click="selectPoint(1, 1)"
                        :active="selectedPoint[1] == 1"
                        >
                        <h2 class="font-size-middle">
                            2 business day for micropayment verification
                        </h2>
                    </BankRow>
                    <BankRow title="Make payment" :index="3" :streak="false"
                        @click="selectPoint(1, 2)"
                        :active="selectedPoint[1] == 2"
                        >
                        <h2 class="font-size-middle">Once verification is successful, simply pay online</h2>
                        <span class="font-size-middle">
                          Funds take 9-10 business days to reach the supplier’s account
                        </span>
                    </BankRow>
                </div>
                <div class="display"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import MainPageHeader from '../components/MainPageHeader.vue';
    import BankTabber from '../components/bank/BankTabber.vue';
    import BankRow from '../components/bank/BankRow.vue';

    export default {
        name: 'BankPage',
        components: {
            MainPageHeader,
            BankTabber,
            BankRow,
        },
        data() {
            return {
                activeTab: 0,
                selectedPoint: [ 0, 0 ],
            };
        },
        mounted() {
        },
        methods: {
            selectPoint(tabIndex, pointIndex) {
                const points = this.selectedPoint.slice();

                points[tabIndex] = pointIndex;

                this.selectedPoint = points;
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";

    .BankPage {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr auto;
        grid-template-areas: 'header'
            'content'
            'footer';
        min-height: 100vh;
    }

    .MainPageHeader {
        grid-area: header;
    }

    .Footer {
        grid-area: footer;
    }

    .content {
        grid-area: content;

        padding: 0 200px;
        margin: 0 auto;
        margin-top: 50px;
        margin-bottom: 200px;
        width: 100%;
        max-width: 2000px;

        .how-it-works {
            font-weight: normal;
            text-align: center;
            margin: 0;
        }

        .sub-header {
            font-weight: normal;
            text-align: center;
        }

        .tabber {
            margin: 0 auto;
            max-width: 500px;
            margin-top: 3em;
        }

        .row {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }
</style>
